module.exports = __webpack_public_path__ + "static/img/step-1.f5af3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/chrome/step-1.png
// module id = HEug
// module chunks = 1